import {Dialog, DialogActions, DialogContent, DialogTitle, TextField, WithStyles, withStyles} from '@material-ui/core';
import Button from "@components/common/button/Button";
import * as React from 'react';
import { FamilyMemberType } from '@services/family/family.constants';
import * as FamilyActions from '@services/family/family.actions';

import TranslateNew from '@translate/TranslateNew';
import { connect } from 'react-redux';
import { IFamilyMember } from '@app-types/websocket/family.types';
import ArticleLink from '@components/common/ArticleLink';
import {AddFamilyMemberStyle as styles} from './addFamilyMember.style';

const tn :TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof styles> {
  isOpen: boolean;
  onClose: () => void;
  role:FamilyMemberType;
  addFamilymember: (data: IFamilyMember) => void;
}

interface IState {
  firstName: string;
  lastName: string;
  yearBorn: number;
  firstNameError: boolean,
  lastNameError: boolean,
  yearBornError: boolean,
}



class AddFamilyMemberDialog extends React.Component<IProps,IState> {
  
  constructor(props: IProps) {
    super(props);

    this.state = {
      firstName: "",
      lastName: "",
      yearBorn: 2008,
      firstNameError: false,
      lastNameError: false,
      yearBornError: false,
    };

}

  public render() {

    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.props.onClose}
      >
          <ArticleLink style={{display: "flex", margin: "10px", justifyContent: "flex-end", color: "inherit", textDecoration: "none"}}
            article="/app/knowledge/596">{tn.lang.readMore}
          </ArticleLink>
          <DialogTitle>
            {this.props.role===FamilyMemberType.PARENT
              ? tn.lang.addParent
              : this.props.role===FamilyMemberType.CHILD
                ? tn.lang.addChild
                : tn.lang.addViewer
            }
          </DialogTitle>
          <DialogContent style={{display:'flex', flexDirection:'column', gap:'20px'}}>
            <TextField
              label={tn.lang.name}
              id="firstName"
              name="firstName"
              autoFocus={true}
              classes={this.state.firstNameError?{root:this.props.classes.redMarked}:undefined}
              variant='outlined'
              inputProps={{ maxLength: 28 }}
              onBlur={() => this.setState({firstNameError:(this.state.firstName.length < 2)})}
              onChange={(e) => this.setState({firstName:e.target.value, firstNameError:false})}
              value={this.state.firstName}
            />
            <TextField
              label={tn.lang.sirname}
              style={this.props.role===FamilyMemberType.CHILD?{display:'none'}:{}}
              classes={this.state.lastNameError?{root:this.props.classes.redMarked}:undefined}
              id="lastName"
              name="lastName"
              autoFocus={false}
              variant='outlined'
              inputProps={{ maxLength: 28 }}
              onChange={(e) => this.setState({lastName:e.target.value, lastNameError:false})}
              value={this.state.lastName}
            />
            <TextField
              label={tn.lang.dateOfBirth}
              style={this.props.role===FamilyMemberType.CHILD
                ?{}
                :{display:'none'}}
              classes={this.state.yearBornError?{root:this.props.classes.redMarked}:undefined}
              id="yearBorn"
              name="yearBorn"
              type="number" 
              inputMode="numeric"
              variant='outlined'
              inputProps={{ maxLength: 4 }}
              onBlur={() => this.setState({yearBornError:(this.state.yearBorn === Number.NaN 
                ||this.state.yearBorn < 1990 || this.state.yearBorn > 2030)})}
              onChange={(e) => this.setState({yearBorn:Number.parseInt(e.target.value,10), yearBornError:false})}
              value={this.state.yearBorn}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose}>{tn.lang.cancel}</Button>
            <Button variant='contained' color='primary' onClick={this.handleSubmit}>
              {this.props.role===FamilyMemberType.PARENT
                ? tn.lang.addParent
                : this.props.role===FamilyMemberType.CHILD
                  ? tn.lang.addChild
                  : tn.lang.addViewer
              }
            </Button>
          </DialogActions>
      </Dialog>
    );
  }

  private handleSubmit = () => {
    let valid = false;
    if (this.props.role === FamilyMemberType.CHILD) {
      if (this.state.firstName.length >= 2 && this.state.yearBorn > 1999 && this.state.yearBorn < 2030) {
        valid = true;
      }
    } else {
      if (this.state.firstName.length >= 2) {
        valid = true;
      }
    }
    if (valid) {
      const newMember: IFamilyMember = {
        avatar: 0,
        id: 0,
        lastOnline: 0,
        sex: "UNKNOWN",
        inviteTime: 0,
        inviteEmail: "",
        online: false,
        lastName: this.state.lastName,
        firstName: this.state.firstName,
        yearBorn: (this.state.yearBorn && this.state.yearBorn > 1990 && this.state.yearBorn < 2030)?this.state.yearBorn:undefined,
        color:"#000",
        role: this.props.role,
      };
      this.props.addFamilymember(newMember);
      this.props.onClose();
    }
  }
}

const mapDispatchToProps = {
  addFamilymember: FamilyActions.addFamilyMember,
};
export default connect(undefined, mapDispatchToProps)(withStyles(styles)(AddFamilyMemberDialog));



// WEBPACK FOOTER //
// ./src/components/extended-family/add-child-dialog/addFamilyMember.tsx